
import { defineComponent } from "vue";
import { keyStore } from "Store";

export default defineComponent({
  computed: {
    isLoading() {
      const isBusy = this.$store.getters[keyStore.ISBUSY] || false;
      if (isBusy) {
        $(document.body).addClass("body-no-padding");
      } else {
        $(document.body).removeClass("body-no-padding");
      }
      return isBusy;
    },
  },
});
